module.exports = __webpack_public_path__ + "img/not_found.f2cb359f.gif";